import { Component, ViewEncapsulation } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'rinno';

  constructor(private authService: AuthService,
              private router: Router){}

  ngOnInit(): void {

  }

  isHeaderVisible(): boolean {
    const urlsWithoutHeader: string[] = ['/eligibility-tool'];
    return this.authService.isLoggedIn() && !urlsWithoutHeader.includes(this.router.url);
  }
}
